var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-group-container noselect"},_vm._l((_vm.options),function(option){return _c('div',{key:option.title,staticClass:"item noselect shadow",class:`${_vm.selected.title == option.title ? 'selected' : ''} ${
      _vm.rounded ? 'circles' : ''
    }`,on:{"click":function($event){_vm.select(option);
      _vm.$emit('input', option);}}},[(option.img)?_c('img',{attrs:{"src":_vm.api.GET_IMAGE(option.img),"alt":_vm.options.title}}):_vm._e(),_c('span',[_vm._v(_vm._s(option.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }